import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { getAccessTokenSilently } from "../shared/Auth0Utility";

export function determineBaseUrl(): string {
  if (import.meta.env.VITE_RUN_ENV === "env-dev") {
    return "https://env-dev-api.rebootmotion.com/";
  } else if (import.meta.env.VITE_RUN_ENV === "env-stage") {
    return "https://env-stage-api.rebootmotion.com/";
  } else if (import.meta.env.VITE_RUN_ENV === "env-prod") {
    return "https://api.rebootmotion.com/";
  }
  return "http://localhost:8000/";
}

export const emptyApi = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: determineBaseUrl(),
    prepareHeaders: async (headers) => {
      const authToken = await getAccessTokenSilently();
      if (authToken) {
        headers.set("authorization", `Bearer ${authToken}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: [
    "Sessions",
    "User",
    "Players",
    "Org",
    "UploadSession",
    "Reports",
    "ApiKeys",
    "RequestedAnalyses",
    "PlayerGroups",
    "PlayerGroupById",
    "FlaggedReports",
    "AggregateReports",
    "Visualizations",
  ],
});
